import logo from './logo.svg';
import './App.css';
import Layout from './components/Layout/Layout';
import {themeContext} from './Context'
import { useContext } from 'react';
function App() {
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode;
  return (
    <div className={`App ${darkMode ? 'dark_mode':'light_mode'}`} style={{ backgroundImage: !darkMode && 'linear-gradient(to right, #bdc2e8 , #e6dee9)'}}>
      <Layout></Layout>
    </div>
  );
}

export default App;
